(function () {
  function tidy(value) {
    if (!value || !/[0-9]/.test(value)) return value;
    return value
      .replace(/\.00(?=\s|$)/g, '')
      .replace(/\s+[A-Z]{3}\s*$/g, '')
      .trim();
  }

  function clean(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var prices = scope.querySelectorAll('span.money, [data-nsq-clean-price]');
    for (var i = 0; i < prices.length; i++) {
      var next = tidy(prices[i].textContent);
      if (next && prices[i].textContent !== next) prices[i].textContent = next;
    }
    if (scope.matches && scope.matches('span.money, [data-nsq-clean-price]')) {
      var own = tidy(scope.textContent);
      if (own && scope.textContent !== own) scope.textContent = own;
    }
  }

  function fixCompactProductCarousels() {
    var carousels = document.querySelectorAll('.collection-carousel.slick-initialized');
    for (var i = 0; i < carousels.length; i++) {
      var carousel = carousels[i];
      var slides = carousel.querySelectorAll('.slick-slide:not(.slick-cloned)');
      if (slides.length > 0 && slides.length < 4) {
        carousel.style.display = 'block';
        var list = carousel.querySelector('.slick-list');
        if (list) list.style.width = '100%';
      }
    }
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
      window.jQuery('.collection-carousel.slick-initialized').slick('setPosition');
    }
  }

  function localizeLeapHero() {
    var hero = document.querySelector('#shopify-section-1578474099783');
    if (!hero) return;
    var tagline = hero.querySelector('.slide-text');
    if (!tagline) return;
    var isZh = (document.documentElement.lang || '').toLowerCase().indexOf('zh') === 0;
    tagline.textContent = isZh ? '簡約，不等於簡單。' : 'MINIMAL, NEVER ORDINARY.';
  }

  function start() {
    clean(document);
    fixCompactProductCarousels();
    localizeLeapHero();
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var target = records[i].target.nodeType === 3 ? records[i].target.parentElement : records[i].target;
        if (target) clean(target);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    setTimeout(function () { clean(document); fixCompactProductCarousels(); localizeLeapHero(); }, 500);
    setTimeout(function () { clean(document); fixCompactProductCarousels(); localizeLeapHero(); }, 1500);
    setTimeout(function () { clean(document); fixCompactProductCarousels(); localizeLeapHero(); }, 3000);
    window.addEventListener('resize', fixCompactProductCarousels);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* NSquare mobile submenu touch fix — 2026-08-21 */
(function () {
  if (window.__nsqMobileMenuFix) return;
  window.__nsqMobileMenuFix = true;

  function directSubmenu(item) {
    if (!item) return null;
    for (var i = 0; i < item.children.length; i += 1) {
      if (item.children[i].classList && item.children[i].classList.contains('sub-menu-mobile')) {
        return item.children[i];
      }
    }
    return null;
  }

  function openSubmenu(trigger, event) {
    var action = trigger.closest('.nav-action');
    var item = action && action.closest('li.dropdown');
    var submenu = directSubmenu(item);
    if (!action || !item || !submenu) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    item.classList.add('is-open');
    action.classList.add('is-open');
    submenu.classList.add('is-open');
    submenu.style.display = 'block';
    submenu.style.visibility = 'visible';
    submenu.style.opacity = '1';
    submenu.style.transform = 'translateX(0)';

    var siblings = item.parentElement ? item.parentElement.children : [];
    for (var i = 0; i < siblings.length; i += 1) {
      if (siblings[i] !== item && siblings[i].classList) siblings[i].classList.add('is-hidden');
    }
  }

  function closeSubmenu(back, event) {
    var submenu = back.closest('.sub-menu-mobile');
    var item = submenu && submenu.closest('li.dropdown');
    if (!submenu || !item) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    item.classList.remove('is-open');
    var action = item.querySelector(':scope > .nav-action');
    if (action) action.classList.remove('is-open');
    submenu.classList.remove('is-open');
    submenu.style.display = '';
    submenu.style.visibility = '';
    submenu.style.opacity = '';
    submenu.style.transform = '';

    var siblings = item.parentElement ? item.parentElement.children : [];
    for (var i = 0; i < siblings.length; i += 1) {
      if (siblings[i].classList) siblings[i].classList.remove('is-hidden');
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('#site-nav-mobile [data-toggle-menu-mb]');
    if (toggle) {
      openSubmenu(toggle, event);
      return;
    }

    var back = event.target.closest && event.target.closest('#site-nav-mobile .menu-mb-title');
    if (back) closeSubmenu(back, event);
  }, true);
}());
